// Shared physical size for every invitation template — keep all templates
// and the builder's print/thumbnail logic in sync from a single source.
export const CARD_W_MM = 130;
export const CARD_H_MM = 85;

const MM_TO_PX = 3.7795275591; // 96dpi CSS reference pixel

export const CARD_W_PX = CARD_W_MM * MM_TO_PX;
export const CARD_H_PX = CARD_H_MM * MM_TO_PX;

export const CARD_W = `${CARD_W_MM}mm`;
export const CARD_H = `${CARD_H_MM}mm`;
